import { useEffect, useMemo, useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import DictionaryRepository from '@/creditflowresearch/infrastructure/repository/DictionaryRepository';
import { useCorporateBondScreenerSidebarFilterContext } from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import useCheckboxFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useCheckboxFilter';
import mapToCheckboxOptions from '@/creditflowresearch/application/BondScreener/mapToCheckboxOptions';

const useStatusSection = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();
  const repository = getContainer().get(DictionaryRepository);
  const [dictionary, setDictionary] = useState([]);

  useEffect(() => {
    const loadDictionary = async () => {
      setDictionary(await repository.getDealStatuses());
    };
    loadDictionary();
  }, []);

  const items = useMemo(
    () => mapToCheckboxOptions(filters?.statusIds, dictionary),
  [dictionary, filters?.statusIds]);

  return useCheckboxFilter<number>({ filterKey: 'includedStatusIds', items });
};

export default useStatusSection;
